module.exports = __webpack_public_path__ + "static/covid19@2x-f9888421d35fe473b509d60b7b576ac4.png";